const DUMMY_ELEMENT_ID = 'window-height-measurer'

function createDummyElement() {
  const dummyElement = document.createElement('div')

  dummyElement.id = DUMMY_ELEMENT_ID
  dummyElement.style = 'position: fixed; width: 100%; height: 100%; top: 0; left: 0; z-index: -1;'

  document.body.appendChild(dummyElement)

  return dummyElement
}

export default function () {
  const element = document.getElementById(DUMMY_ELEMENT_ID) || createDummyElement()

  return element.getBoundingClientRect().height
}
